export class LoginFailedError extends Error {
    constructor(message, user) {
        super(message);
        this.user = user;
        this.name = "LoginFailerError";
    }
}
